import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

function App() {
  const { t } = useTranslation();
  const forwardLink = "https://t.me/FriendFarmBot/app";

  return (
    <Container maxWidth="sm">
      <Box sx={{ textAlign: 'center', mt: 5 }}>
        <Typography variant="h5" gutterBottom>
          {t('gameMovedToNewBot')}
        </Typography>
        <Typography variant="body1">
          {t('pleaseContinuePlayingHere')}:
        </Typography>
        <a
          href={forwardLink}
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: 'block', marginTop: '10px', fontWeight: 'bold' }}
        >
          {forwardLink}
        </a>
      </Box>
    </Container>
  );
}

export default App;
